import React from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { EmpathySection } from './components/sections/EmpathySection';
import { DetailsSection } from './components/sections/DetailsSection';
import { OfferSection } from './components/sections/OfferSection';
import { FooterSection } from './components/sections/FooterSection';
import { FloatingCTA } from './components/ui/FloatingCTA';
export function App() {
  return <div className="min-h-screen bg-[#FAF7F2] font-sans text-[#4A3F35]" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <EmpathySection data-id="element-3" />
        <DetailsSection data-id="element-4" />
        <OfferSection data-id="element-5" />
        <FooterSection data-id="element-6" />
      </main>
      <FloatingCTA data-id="element-7" />
    </div>;
}